import { render, staticRenderFns } from "./uploadFiles1.vue?vue&type=template&id=677a629d&scoped=true&"
import script from "./uploadFiles1.vue?vue&type=script&lang=js&"
export * from "./uploadFiles1.vue?vue&type=script&lang=js&"
import style0 from "./uploadFiles1.vue?vue&type=style&index=0&id=677a629d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677a629d",
  null
  
)

export default component.exports